export default {
  id: 21,
  title: 'Target #21 - SitePoint Logo',
  url: 'https://cssbattle.dev/play/21',
  colors: ['#222', '#F2994A', '#2D9CDB'],
  solution:
    '<a a><a b><a c><a d><style>body{background:#222}a{position:fixed}a[a],a[b]{background:#f2994a}a[a]{width:100;height:30;top:93;left:120;transform:rotate(-45deg);border-top-left-radius:10px}a[b]{width:60;height:30;top:143;left:140;transform:rotate(45deg);border-top-right-radius:5px}a[c],a[d]{background:#2d9cdb}a[c]{width:100;height:30;top:177;left:178;transform:rotate(135deg);border-top-left-radius:10px}a[d]{width:60;height:30;top:127;left:198;transform:rotate(-135deg);border-top-right-radius:5px}</style>',
}
